import React, { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import history from '../../../History';
import GridDisplay from "../../GridDisplay/GridDisplay";

function NoLayoutRouter() {

    return (
         <div className="app"> 
            <div className="site-content" style={{overflowY:'auto', overflowX:'auto', marginRight:0,height:'100vh' }}>
                <div id="container-content" style={{ height: "100%", width: "100%" }}>
                    <Router history={history}>
                        <Switch>
                            <Route path="/CM2WebShare/Grid" exact><GridDisplay /></Route>
                        </Switch>
                    </Router>
                </div>
            </div>
        </div>       
    );
}

export default NoLayoutRouter;